define('AwaLabs.BackboneFormView.GoogleCaptchaToken', [
	'Backbone.FormView',
	'SC.Configuration',
	'jQuery',
	'underscore'
], function AwaLabsBackboneFormViewGoogleCaptchaToken(
	BackboneFormView,
	Configuration,
	jQuery,
	_
) {
	'use strict';

	_.extend(BackboneFormView, {
		saveForm: _.wrap(BackboneFormView.saveForm, function saveForm(fn) {
			var self = this;
			var result;
			var fnArguments = _.toArray(arguments).slice(1);
			var event = fnArguments[0];
			var $savingForm = this.$el.find('form');
			var captchaAction = $savingForm.data('googlecaptcha-action') || $savingForm.serializeObject()['googlecaptcha-action'];
			var layout = this.application ? this.application.getComponent('Layout') : '';
			var deferred = jQuery.Deferred();

			function executeSave() {
				try {
					var result = fn.apply(self, fnArguments);
					if (result && typeof result.then === 'function') {
						result.then(function thenFn(res) {
							deferred.resolve(res);
						}).fail(function failFn(err) {
							deferred.reject(err);
						});
					} else {
						deferred.resolve(result);
					}
				} catch (e) {
					deferred.reject(e);
				}
			}
			if (captchaAction && layout) {
				layout.cancelableTrigger('before:addGoogleCaptchaToken', { view: self });

				if (captchaAction === 'guest') {
					event.preventDefault();
				}

				grecaptcha.ready(function ready() {
					grecaptcha.execute(Configuration.get('googlecaptcha.siteKey'), { action: captchaAction })
						.then(function then(token) {
							self.model.set({ 'grecaptcha-token': token });
							layout.cancelableTrigger('after:addGoogleCaptchaToken', { token: token, view: self });
							executeSave();
						})
						.catch(function catchFn(err) {
							deferred.reject(err);
						});
				});
			} else {
				executeSave();
			}

			return deferred.promise();
		})
	});
});
